<template>
  <div class="SignUpView">
    <!-- Desktop Logo !-->
    <img
      :src="logo"
      class="SignUpView__logo--primary"
    >
    <!-- Left Panel !-->
    <div
      :style="{backgroundImage: `url(${leftImg})`}"
      class="SignUpView__left-side bg-color-secondary"
    >
      <div class="SignUpView__left-side__background text-center color-white d-flex flex-column">
        <span class="SignUpView__left-side__background__content m-s-b font-xl">{{ leftTitle }}</span>
        <span class="SignUpView__left-side__background__content font-l">{{ leftSubtitle }} </span>
      </div>
    </div>
    <!-- Right Panel !-->
    <div class="SignUpView__right-side">
      <MuiNotificationList />
      <!-- Responsive Logo !-->
      <div class="text-center full-width center">
        <img
          :src="logoResponsive"
          class="SignUpView__logo--responsive"
        >
      </div>
      <!-- View -->
      <div class="SignUpView__right-side__wrapper full-width">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import { MuiNotificationList } from '@ubeeqo/motion-ui';
// TODO:
// Remove brunel hardcoded logo
import Logo from '@/assets/brunel_logo.svg';
import LogoResponsive from '@/assets/brunellogo_black.svg';
import Background from '@/assets/brunel_private.jpg';

export default {
  components: {
    MuiNotificationList,
  },
  props: {
    logoDesktop: {
      // TODO:
      default: '@/assets/brunellogo.png',
      type: [String, Object],
    },
    logoMobile: {
      default: '@/assets/brunellogo_black.svg',
      type: [String, Object],
    },
    leftImage: {
      default: '~@/assets/business-signup.jpg',
      type: [String, Object],
    },
    leftTitle: {
      default: '',
      type: String,
    },
    leftSubtitle: {
      default: '',
      type: String,
    },
  },
  computed: {
    leftImg() {
      return Background;
    },
    logo() {
      return Logo;
    },
    logoResponsive() {
      return LogoResponsive;
    },
  },
};
</script>
